import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { login as loginAction } from '../features/auth/authSlice';
import { useAuth } from '../components/auth-context/AuthContext';
import {
    createBrowserRouter,
    useLocation,
    RouterProvider,
    createHashRouter,
    Navigate,
} from 'react-router-dom';
import NavigationLayout from '../components/layout/NavigationLayout';
import AssignmentsReports from '../pages/AssignmentsReports';
import LeadGroupAcademy from '../pages/LeadGroupAcademy';
import Nucleus from '../pages/Nucleus';
import ProtectedRoute from '../components/protected-routes/ProtectedRoute';
import StudentList from '../pages/StudentList';
import BookLibrary from '../pages/BookLibrary';
import BookView from '../pages/BookView';
import Error from '../pages/errorPages/Error';
import AuthenticatedRoute from '../components/protected-routes/AuthenticatedRoute';
import BuildrLabActivity from '../pages/BuildrLabActivity';
import IframeDisplay from '../pages/IframeDisplay';
import ActiveTeachLogin from '../pages/ActiveTeachLogin';
import Jasper from '../pages/Jasper';
import ReportsIframe from '../components/Reports/ReportsIframe';
import HelpAndFAQ from '../pages/HelpAndFAQ';
import ResourceViewer from '../components/resource-viewer/ResourceViewer';
import LoadingSpinner from '../components/layout/LoadingSpinner';
import StudentAppReport from '../pages/StudentAppReport';

<Navigate to="/login" replace />;

function SignInRedirect() {
    const location = useLocation();
    const searchParams = location.search; // Extract query params (e.g., ?utm_source=google)

    return <Navigate to={`/login${searchParams}`} replace />;
}

const routes = [
    {
        path: '/',
        element: (
            <ProtectedRoute>
                <NavigationLayout />
            </ProtectedRoute>
        ),
        children: [
            { path: 'book-library', element: <BookLibrary /> },
            { path: 'assignments-reports', element: <AssignmentsReports /> },
            { path: 'reports', element: <ReportsIframe /> },
            { path: 'student-app-usage', element: <StudentAppReport />},
            { path: 'student-list', element: <StudentList /> },
            { path: 'jasper', element: <Jasper /> },
            { path: 'assessments', element: <Jasper /> },
            { path: 'lead-group-academy', element: <LeadGroupAcademy /> },
            { path: 'nucleus', element: <Nucleus /> },
            { path: 'book', element: <BookView /> },
            { path: 'lab-activity', element: <BuildrLabActivity /> },
            { path: 'help-and-faq', element: <HelpAndFAQ /> },
            { path: 'iframe-open', element: <IframeDisplay /> },
            { path: 'resource', element: <ResourceViewer /> },
            { path: 'launch', element: <LoadingSpinner /> },
            // Default path
            { path: '', element: <Navigate to="/book-library" /> },
            // Catch-all for unmatched paths
            { path: '*', element: <Navigate to="/book-library" /> },
        ],
        errorElement: <Error />,
    },
    {
        path: '/login',
        element: (
            <AuthenticatedRoute>
                <ActiveTeachLogin />
            </AuthenticatedRoute>
        ),
    },
    // {
    //     path: '/login',
    //     element: (
    //         <AuthenticatedRoute>
    //             <Login />
    //         </AuthenticatedRoute>
    //     ),
    // },
    { path: '/signin', element: <SignInRedirect /> },
];
let router: any;
if (process.env.REACT_APP_INSTALLATION_MODE === 'webapp') {
    router = createBrowserRouter(routes);
} else {
    router = createHashRouter(routes);
}

const MainComponent: React.FC = () => {
    const dispatch = useDispatch();
    const { login } = useAuth();

    useEffect(() => {
        if (process.env.REACT_APP_INSTALLATION_MODE !== 'desktop') {
            const tokenFromStorage = localStorage.getItem('token');
            if (tokenFromStorage) {
                const user = localStorage.getItem('user')
                    ? JSON.parse(localStorage.getItem('user') as string)
                    : null;
                if (user) {
                    login(user, tokenFromStorage);
                    dispatch(loginAction({ user, token: tokenFromStorage }));
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    return <RouterProvider router={router} />;
};

export default MainComponent;
